import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getContentFullPathUsingProvidedShortContentId } from "../../services/content.service";
import { CircularProgress } from "@mui/material";

export default function Short() {
  const { contentId } = useParams<{ contentId: string }>();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery(
    ["getShortUrl", contentId],
    () => getContentFullPathUsingProvidedShortContentId({ contentId }),
    {
      onSuccess: (data) => {
        if (data && data.url) {
          navigate(data.url);
        }
      },

      onError: (error: any) => {
        if (error.response && error.response.status === 403) {
          console.error("Forbidden error occurred:", error);
          navigate("/forbidden");
        } else if (error.response && error.response.status === 404) {
          console.error("Not Found error occurred:", error);
          navigate("/notfound");
        } else {
          console.log("An error occurred:", error);
          navigate("/error");
        }
      },
      enabled: !!contentId,
      retry: false,
    }
  );

  if (isLoading)
    return (
      <div className="flex justify-center items-center h-screen">
        <CircularProgress style={{ color: "#DCAA00" }} />
      </div>
    );

  return <div></div>;
}
